<!-- @format -->
<template>
    <post-hv-news v-if="this.$route.name === 'hvnews'"
        :post="post"
        show-location
        :show-post-type="false"
        @single-post-view="$emit('single-post-view', $event)"
    />
    <post v-else
        :post="post"
        show-location
        :show-post-type="false"
    />
</template>

<script>
import Post from './Post.vue';
import PostHvNews from './PostHvNews.vue';

export default {
    components: {
        Post,
        PostHvNews
    },
    props: {
        post: {
            type: Object,
            required: true
        }
    }
};
</script>
